module.exports = __webpack_public_path__ + "static/media/matnrrd_2-721w.044c29a7.png";